(function (ws) {
    const OPEN_CLASS = 'comp-notification--open';

    ws.views.notification = Backbone.View.extend({
        events: {
            'click [data-notif-close]': 'hideNotification'
        },

        initialize() {
            this.open = false;

            this.hideIfOutsideClick = e => {
                // only hide if click is outside element
                if (!this.el.contains(e.target)) {
                    this.hideNotification();
                }
            };
        },

        showNotification() {
            this.open = true;
            this.$el.addClass(OPEN_CLASS);

            this.timeout = setTimeout(() => {
                this.timeout = null;
                this.hideNotification();
            }, 5000);

            document.body.addEventListener('click', this.hideIfOutsideClick);
        },

        hideNotification() {
            if (!this.open) {
                return;
            }

            this.$el.removeClass(OPEN_CLASS);
            document.body.removeEventListener('click', this.hideIfOutsideClick);

            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.open = false;
        }
    });

})(westcon);
